import { ProgressSpinner } from "primereact/progressspinner";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";

const View = () => {
  const { code } = useParams();
  const [forecast, setForecast] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await Http.get(`/demand-forecast/${code}`);
        setForecast(res.data);
      } catch (e) {
        console.error("Fetch error:", e);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [code]);

  if (loading || !forecast) {
    return (
      <div className="am-mainpanel">
        <IsLogin></IsLogin>
        <div className="am-pagebody">{loading ? <ProgressSpinner /> : <p>Forecast not found.</p>}</div>
      </div>
    );
  }

  const segmentDates = forecast.segment_dates || [];

  return (
    <div>
      <IsLogin></IsLogin>
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">View Demand Forecast</h5>
          <div>
            <Link to={"/edit-demand-forecast/" + code} className="btn btn-primary">
              <i className="fa fa-pencil mg-r-6"></i> Edit
            </Link>
            <Link to="/demand-forecast" className="btn btn-secondary ms-1">
              <i className="fa fa-arrow-left mg-r-6"></i> Back to List
            </Link>
          </div>
        </div>

        <div className="am-pagebody">
          <div className="card pd-20 pd-sm-40">
            <div className="row">
              <div className="col-lg">
                <label>Code</label>
                <input type="text" className="form-control" value={forecast.code} disabled />
              </div>
              <div className="col-lg">
                <label>Start Date</label>
                <input type="date" className="form-control" value={forecast.start_date || ""} disabled />
              </div>
              <div className="col-lg">
                <label>End Date</label>
                <input type="date" className="form-control" value={forecast.end_date || ""} disabled />
              </div>
              <div className="col-lg">
                <label>Forecasting Month</label>
                <input type="text" className="form-control" value={forecast.forecasting_duration || ""} disabled />
              </div>
            </div>

            <div className="table-responsive mt-3">
              <table className="table table-sm table-bordered" style={{ fontSize: "12px" }}>
                <thead>
                  <tr>
                    <th>Product Code</th>
                    <th>Product Name</th>
                    <th>Pack Size</th>
                    <th>Weight</th>
                    <th>Length</th>
                    <th>Height</th>
                    <th>Width</th>
                    <th>Price</th>
                    <th>DP Ctn/Bag</th>
                    {segmentDates.map((segment, index) => (
                      <th key={index} className="text-center">
                        <strong>Segment {index + 1}</strong>
                        <div style={{ fontSize: "10px", fontWeight: "normal" }}>
                          {segment.start_date || "-"} &rarr; {segment.end_date || "-"}
                        </div>
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {forecast.rows.map((row) => (
                    <tr key={row.id}>
                      <td>{row.code}</td>
                      <td>{row.name}</td>
                      <td>{row.pack_size || "-"}</td>
                      <td>{row.weight ?? "-"}</td>
                      <td>{row.length ?? "-"}</td>
                      <td>{row.height ?? "-"}</td>
                      <td>{row.width ?? "-"}</td>
                      <td>{Number(row.price || 0).toFixed(2)}</td>
                      <td>{Number(row.dp_ctn_bag || 0).toFixed(2)}</td>
                      {segmentDates.map((_, index) => (
                        <td key={index} className="text-center">
                          {row.segments[index] ? row.segments[index].segment_qty : 0}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default View;
